var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndirectReferralsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "User-Multiple-Group--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "User Multiple Group Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-multiple-group--close-geometric-human-multiple-person-up-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M8 4.50003c0 1.65685 -1.34315 3 -3 3s-3 -1.34315 -3 -3 1.34315 -3 3 -3 3 1.34315 3 3ZM5 8.5c-2.76142 0 -5 2.2386 -5 5 0 0.2761 0.223858 0.5 0.5 0.5h9c0.27614 0 0.5 -0.2239 0.5 -0.5 0 -2.7614 -2.23858 -5 -5 -5Zm8.5001 5.5h-2.3225c0.0472 -0.1584 0.0725 -0.3263 0.0725 -0.5 0 -2.0411 -0.9784 -3.85363 -2.49178 -4.99426 0.08011 -0.00381 0.16071 -0.00574 0.24176 -0.00574 2.76142 0 5.00002 2.2386 5.00002 5 0 0.2761 -0.2239 0.5 -0.5 0.5ZM9.00008 7.50003c-0.30173 0 -0.59305 -0.04455 -0.86775 -0.12742 0.69409 -0.75643 1.11775 -1.76503 1.11775 -2.87258s-0.42366 -2.11615 -1.11776 -2.87259c0.27471 -0.08287 0.56603 -0.12741 0.86776 -0.12741 1.65682 0 3.00002 1.34315 3.00002 3s-1.3432 3 -3.00002 3Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndirectReferralsIcon);
export default __webpack_public_path__ + "static/media/indirect-referrals-icon.6af57bb86fcc299cccf581850835e060.svg";
export { ForwardRef as ReactComponent };